module.exports = __webpack_public_path__ + "static/media/character.626b5352.svg";